let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4g6pn")).then(() => parcelRequire('kj4YD'));